const menuItems = [
  {
    title: "Imóveis MCMV",
    subItems: [
      { label: "Apartamento", href: "" },
      { label: "Casa", href: "" },
    ],
  },
  {
    title: "Imóveis na Planta",
    subItems: [
      { label: "Apartamento", href: "" },
      { label: "Casa", href: "" },
      { label: "Sobrado", href: "" },
      { label: "Sala", href: "" },
      { label: "Kitnet", href: "" },
    ],
  },
  {
    title: "Imóveis Novos",
    subItems: [
      { label: "Apartamento", href: "" },
      { label: "Casa", href: "" },
      { label: "Sobrado", href: "" },
      { label: "Sala", href: "" },
      { label: "Kitnet", href: "" },
    ],
  },
  {
    title: "Venda seu Imóvel",
    href: "", // Item sem dropdown
  },
];

export default menuItems;
